export default {
  common: {
    nav: {
      home: "홈",
      find_offer_help: "도움 찾기 / 제공",
      celebrate: "삶을 기리다",
      family_tree: "가족 나무",
      events: "이벤트",
      civic_reports: "시민 보고",
      neighborhood_pulse: "이웃의 맥박",
      weather: "날씨",
      nature: "자연",
      marketplace: "마켓",
      news: "뉴스",
      causes: "선한 목적",
      more: "더보기",
    },
    header: { sign_in: "로그인", join: "Social Pulse 가입", language: "언어", search: "검색" },
    tagline: "커뮤니티를 연결하고 · 삶에 힘을 실어주며 · 사회적 자본을 구축합니다",
    locality: { viewing_from: "현재 보고 계신 위치", change: "변경", set_your_location: "위치 설정" },
    news: { title: "오늘의 브리핑.", play_briefing: "일일 브리핑 재생", listen: "듣기", translate: "번역" },
  },
};
